<template>
	<footer>
		<p><img src="../assets/logo.png"></p>
		<h3><a href="http://biomall.cs.uno.edu">&copy;2017 Bioinformatics and Machine Learning Lab</a></h3>
		<p>portal developed by <a href="http://nishan.rayamajhee.com">nishan.rayamajhee</a></p>
	</footer>
</template>
<script>
export default{}
</script>
<style>
footer {
	margin-top: calc(3 *var(--gap-huge));
	text-align: center;
}
footer p {
	color: var(--text-faded);
}
footer img {
	max-width: 240px;
}
</style>
